import { configureStore } from '@reduxjs/toolkit'
import userSlice from '../slices/userSlice'
import rankSlice from '../slices/rankSlice'
import flagSlice from '../slices/flagSlice'
export default configureStore({
  reducer: {
      user: userSlice,
      rank: rankSlice,
      flag: flagSlice
  }
})